<template>
  <div class="aboutus">
    <carousel :images="imgs"
              indicator-position="none"
              style="z-index: -1;"
              arrow="never">
      <!-- <div class="header_box">
        <div class="header_title"><span>{{$t('aboutus.name')}}</span></div>
        <div class="header_content">{{$t('aboutus.introduce1')}}</div>
        <div class="header_content">{{$t('aboutus.introduce2')}}</div>
      </div> -->
    </carousel>
    <!-- 说明 -->
    <div class="shuoming"
         v-bind:class="{ en: lang === 'en' }">
      <div class="fixed_width">
        <div class="title">
          {{$t('aboutus.name')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.introduce2')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.introduce21')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.introduce22')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.introduce23')}}
        </div>
        <!-- 优势与核心技术 -->
        <!-- <div class="title2">
          {{$t('aboutus.advantageTitle')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.advantageText')}}
        </div>
        <div class="title3">
          {{$t('aboutus.advantageTitle1')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.advantageText1')}}
        </div>
        <div class="title3">
          {{$t('aboutus.advantageTitle2')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.advantageText2')}}
        </div>
        <div class="title3">
          {{$t('aboutus.advantageTitle3')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.advantageText3')}}
        </div> -->
        <!-- 产品与服务 -->
        <!-- <div class="title2">
          {{$t('aboutus.productsServices')}}
        </div> -->
        <!-- 产品 -->
        <!-- <div class="title4">
          {{$t('aboutus.products')}}
        </div>
        <div class="title3">
          {{$t('aboutus.products1')}}
        </div>
        <div class="title3">
          {{$t('aboutus.products2')}}
        </div>
        <div class="introduce">
          {{$t('aboutus.products2Text')}}
        </div> -->
        <!-- 服务 -->
        <!-- <div class="title4">
          {{$t('aboutus.services')}}
        </div>
        <div class="title3">
          {{$t('aboutus.services1')}}
        </div>
        <div class="introduce bottomEnd">
          {{$t('aboutus.services1Text')}}
        </div> -->
      </div>
    </div>
    <!-- 优势与核心技术 -->
    <div class="fixed_width">
      <div id="declaration"
          class="content_title">{{$t('aboutus.advantageTitle')}}</div>
      <div class="content_subtitle">{{$t('aboutus.advantageText')}}</div>
      <el-row class="box"
              type="flex"
              justify="center">
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;">
          <img class="image" src="@/assets/icon/mind1.png">
          <div class="subtitle">{{$t('aboutus.advantageTitle1')}}</div>
          <div class="content">
            {{$t('aboutus.advantageText1')}}
          </div>
        </el-col>
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;">
          <img class="image" src="@/assets/icon/value1.png">
          <div class="subtitle">{{$t('aboutus.advantageTitle2')}}</div>
          <div class="content">
            {{$t('aboutus.advantageText2')}}
          </div>
        </el-col>
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;">
          <img class="image" src="@/assets/icon/science1.png">
          <div class="subtitle">{{$t('aboutus.advantageTitle3')}}</div>
          <div class="content">
            {{$t('aboutus.advantageText3')}}
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 产品与服务 -->
    <div class="fixed_width">
      <div id="declaration"
          class="content_title">{{$t('aboutus.productsServices')}}</div>
      <!-- <div class="content_subtitle">{{$t('aboutus.advantageText')}}</div> -->
      <!-- <el-row>
        <el-col class="boxTitle" :span="16">{{$t('aboutus.products')}}</el-col>
        <el-col class="boxTitle1" :span="7">{{$t('aboutus.services')}}</el-col>
      </el-row> -->
      <el-row class="box"
              type="flex"
              justify="center">
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;margin-top:40px">
          <img class="image" src="@/assets/icon/mind2.png">
          <div class="subtitle">{{$t('aboutus.products1')}}</div>
          <div class="content">
            <!-- {{$t('aboutus.advantageText1')}} -->
          </div>
        </el-col>
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;margin-top:40px">
          <img class="image" src="@/assets/icon/value2.png">
          <div class="subtitle">{{$t('aboutus.products2')}}</div>
          <div class="content">
            {{$t('aboutus.products2Text')}}
          </div>
        </el-col>
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;margin-top:40px">
          <img class="image" src="@/assets/icon/science2.png">
          <div class="subtitle">{{$t('aboutus.services1')}}</div>
          <div class="content">
            {{$t('aboutus.services1Text')}}
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 内容 -->
    <div class="fixed_width">
      <div id="declaration"
           class="content_title">{{$t('aboutus.declarationName')}}</div>
      <div class="content_subtitle">{{$t('aboutus.declaration')}}</div>
      <el-row class="box"
              type="flex"
              justify="center">
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;">
          <img src="@/assets/icon/mind.png">
          <div class="subtitle">{{$t('aboutus.declaration_title1')}}</div>
          <div class="content">
            {{$t('aboutus.declaration_content1')}}
          </div>
        </el-col>
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;">
          <img src="@/assets/icon/value.png">
          <div class="subtitle">{{$t('aboutus.declaration_title2')}}</div>
          <div class="content">
            {{$t('aboutus.declaration_content2')}}
          </div>
        </el-col>
        <el-col :span="7"
                style="padding-left: 15px; padding-right: 15px;">
          <img src="@/assets/icon/science.png">
          <div class="subtitle">{{$t('aboutus.declaration_title3')}}</div>
          <div class="content">
            {{$t('aboutus.declaration_content3')}}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="fixed_width">
      <div id="companyHistory"
           class="content_title">{{$t('aboutus.hornerName')}}</div>
      <a-timeline mode="alternate"
                  style="margin-bottom: 1rem;">
        <a-timeline-item v-for="(item, index) in items"
                         v-bind:key="index">
          <template v-if="index % 2 === 0">
            <el-row v-if="!mobileDevice"
                    type="flex"
                    align="middle"
                    justify="start"
                    style="transform: translateY(-30%); height: 60px;">
              <el-col class="honer_img"
                      :xs="24"
                      :sm="7">
                <img :src="require(`@/assets/icon/${item.imageUrl}`)"
                     :style="`width: ${item.width}`">
              </el-col>
              <el-col :xs="24"
                      :sm="12"
                      :offset="2">
                <div class="honor_title">{{item.time}}</div>
                <div class="honor_content">{{$t(item.valueIndex)}}</div>
              </el-col>
            </el-row>
            <div v-if="mobileDevice"
                 class="honor_box"
                 style="height: 90px;">
              <div><img :src="require(`@/assets/icon/${item.imageUrl}`)"
                     :style="`width: ${item.width}`"></div>
              <div class="honor_title">{{item.time}}</div>
              <div class="honor_content">{{$t(item.valueIndex)}}</div>
            </div>
          </template>
          <template v-if="index % 2 === 1">
            <el-row v-if="!mobileDevice"
                    type="flex"
                    align="middle"
                    justify="end"
                    style="transform: translateY(-30%); height: 60px;">
              <el-col :xs="24"
                      :sm="12">
                <div class="honor_title">{{item.time}}</div>
                <div class="honor_content">{{$t(item.valueIndex)}}</div>
              </el-col>
              <el-col class="honer_img"
                      :xs="24"
                      :sm="7"
                      :offset="2">
                <img :src="require(`@/assets/icon/${item.imageUrl}`)"
                     :style="`width: ${item.width}`">
              </el-col>
            </el-row>
            <div v-if="mobileDevice"
                 class="honor_box"
                 style="height: 90px;">
              <div><img :src="require(`@/assets/icon/${item.imageUrl}`)"
                     :style="`width: ${item.width}`"></div>
              <div class="honor_title">{{item.time}}</div>
              <div class="honor_content">{{$t(item.valueIndex)}}</div>
            </div>
          </template>
        </a-timeline-item>
      </a-timeline>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/carousel'
import headerImg from '@/assets/images/aboutus_header.png'

export default {
  data() {
    return {
      items: [
        {
          time: '2021/05',
          valueIndex: 'aboutus.202105',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2020/03',
          valueIndex: 'aboutus.202003',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2019/08',
          valueIndex: 'aboutus.201908',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2019/05',
          valueIndex: 'aboutus.201905',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2018/11',
          valueIndex: 'aboutus.201811',
          imageUrl: 'weilai.jpeg',
          width: '0.7rem'
        },
        {
          time: '2018/09',
          valueIndex: 'aboutus.201809',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2018/05',
          valueIndex: 'aboutus.201805',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2018/05',
          valueIndex: 'aboutus.2018052',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2018/04',
          valueIndex: 'aboutus.201804',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2018/02',
          valueIndex: 'aboutus.201802',
          imageUrl: 'dazong.png',
          width: '0.7rem'
        },
        {
          time: '2017/08',
          valueIndex: 'aboutus.201708',
          imageUrl: 'jp.png',
          width: '0.7rem'
        },
        {
          time: '2017/05',
          valueIndex: 'aboutus.2017051',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2017/05',
          valueIndex: 'aboutus.2017052',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2017/03',
          valueIndex: 'aboutus.201703',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2016/05',
          valueIndex: 'aboutus.201605',
          imageUrl: 'didi.png',
          width: '0.61rem'
        },
        {
          time: '2015/12',
          valueIndex: 'aboutus.201512',
          imageUrl: 'songben.png',
          width: '0.7rem'
        },
        {
          time: '2015/06',
          valueIndex: 'aboutus.201506',
          imageUrl: 'autobole.png',
          width: '1.22rem'
        },
        {
          time: '2015/05',
          valueIndex: 'aboutus.201505',
          imageUrl: 'preangel.png',
          width: '1.22rem'
        }
      ],
      imgs: [headerImg]
    }
  },
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      },
      set(val) {
        this.$store.commit('set_mobileDevice', val)
      }
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'aboutus' && Object.keys(this.$route.query).length) {
        this.$nextTick(() => {
          const id = this.$route.query.id
          const top = document.getElementById(id).offsetTop - 80
          document.documentElement.scrollTop = top
          // document.getElementById(id).scrollIntoView()
        })
      }
    }
  },
  components: {
    Carousel
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/content_title.scss";
@import "../../style/header_box.scss";
.aboutus {
  .fixed_width {
    max-width: 1000px;
    margin: 0 auto;
  }

  .content_subtitle {
    color: rgba(156, 156, 156, 1);
    line-height: 23px;
    font-size: 14px;
    font-weight: 400;
    padding: 0px 0.2rem;
  }
  .shuoming {
    margin: 0 auto;
    padding: 0.3rem 0.6rem;
    text-align: left;
    margin-top: -3.53rem;
    height: 5.1rem;
    width: 100%;
    opacity: 0.94;
    padding-bottom: 0px;
    background: linear-gradient(
      135deg,
      rgba(61, 178, 222, 1) 0%,
      rgba(71, 214, 184, 1) 100%
    );

    &.en {
      padding-top: 0.2rem;
      .introduce {
        line-height: 0.3rem;
      }
      
    }

    .title {
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 0.5rem;
      letter-spacing: 0.02rem;
      &.en {
        line-height: 0.58rem;
      }
    }
    .title2{
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 0.5rem;
      letter-spacing: 0.02rem;
      margin-top: 0.3rem;
    }
    .title3{
      font-size: 0.28rem;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 0.5rem;
      letter-spacing: 0.02rem;
      margin-top: 0.2rem;
    }
    .title4{
      font-size: 0.32rem;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 0.5rem;
      letter-spacing: 0.02rem;
      margin-top: 0.2rem;
    }

    .introduce {
      font-size: 0.22rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 0.38rem;
      letter-spacing: 0.01rem;
      margin-top: 0.2rem;
    }
  }
  .boxTitle{
    font-size: 22px;
    font-weight: 500;
    color: rgba(27, 27, 27, 1);
    padding-left: 30px;
    text-align: left;
  }
  .boxTitle1{
    font-size: 22px;
    font-weight: 500;
    color: rgba(27, 27, 27, 1);
    padding-left: 30px;
    text-align: left;
  }
  .box {
    .el-col {
      box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 40px 20px;
      margin: 50px 30px 0px 30px;

      &:hover {
        box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.21);
      }

      .subtitle {
        font-size: 22px;
        font-weight: 500;
        color: rgba(27, 27, 27, 1);
        line-height: 0.33rem;
        margin: 20px 0px;
      }

      .content {
        font-size: 15px;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
          "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 400;
        color: rgba(156, 156, 156, 1);
        line-height: 28px;
        text-align: center;
      }
      .image{
        width: 16%;
      }
    }
  }

  /deep/.ant-timeline-item-left {
    .honor_box {
      margin-left: 0.33rem;
    }

    .honer_img {
      // text-align: right;
      text-align: center;
      padding-left: 0.5rem;
    }
  }

  /deep/.ant-timeline-item-right {
    .honor_box {
      margin-right: 0.33rem;
    }

    .honer_img {
      text-align: center;
      padding-right: 0.5rem;
    }
  }

  /deep/.ant-timeline-item-head-blue {
    background: #1890ff;
  }

  /deep/.ant-timeline-item-tail {
    border-left: 2px solid #069dcc;
  }

  .honor_title {
    font-size: 0.24rem;
    font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue",
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-weight: 500;
    color: rgba(27, 27, 27, 1);
    line-height: 0.36rem;
  }

  .honor_content {
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(133, 133, 133, 1);
    line-height: 0.21rem;
  }

  @media only screen and (max-width: 750px) {
    .shuoming {
      padding: 0.2rem 0.4rem 0.4rem 0.4rem;
      height: auto;
      &.en {
        .introduce {
          font-size: 0.18rem;
          font-weight: 500;
          line-height: 0.26rem;
        }

        .title {
          margin: 0rem;
        }
        .title2 {
          margin: 0.3rem;
        }
        .title3{
          font-size: 0.28rem;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 0.5rem;
          letter-spacing: 0.02rem;
          margin-top: 0.1rem;
        }
        .title4{
          font-size: 0.32rem;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 0.5rem;
          letter-spacing: 0.02rem;
          margin-top: 0.2rem;
        }
      }
    }
    .fixed_width {
      max-width: 100%;
      margin: 0 auto;
      img {
        max-width: 85%;
      }
    }

    .content_subtitle {
      font-size: 14px;
    }

    .box {
      .el-col {
        box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        padding: 0.2rem 0.1rem;
        margin: 0.5rem 0.1rem 0rem 0.1rem;

        // &:hover {
        //   box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.21);
        // }
        // 重新构建
        img {
          max-width: 30%;
          height: 24px;
        }
        .image{
          width: 20%;
          height: auto !important;
        }

        .subtitle {
          font-size: 0.18rem;
          font-weight: 500;
          color: rgba(27, 27, 27, 1);
          line-height: 0.33rem;
          margin: 0.2rem 0rem;
        }

        .content {
          font-size: 0.16rem;
          font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
            "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
            "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
            "Segoe UI Emoji", "Segoe UI Symbol";
          font-weight: 400;
          color: rgba(156, 156, 156, 1);
          line-height: 0.28rem;
          text-align: left;
        }
      }
    }

    /deep/.ant-timeline-item-left {
      .honor_content {
        padding-right: 0.3rem;
      }
    }

    /deep/.ant-timeline-item-right {
      .honor_content {
        padding-left: 0.3rem;
      }
    }

    .honor_content {
      font-size: 0.2rem;
      font-weight: 400;
      color: rgba(121, 121, 121, 1);
      line-height: 0.26rem;
    }
  }
}
</style>
